//@ts-nocheck
import BookingTotalsHeaderItem from '../BookingTotalsHeaderItem/BookingTotalsHeaderItem';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import * as PropTypes from 'prop-types';
import './BookingTotalsHeader.css';

/**
 * Functional React component for rendering a custom booking totals header.
 *
 * @namespace Components
 *
 * @param {Object} props - The component's properties
 * @param {string} [props.id] - The ID for the booking totals header component.
 * @param {Object} [props.data] - The data for the booking totals header component.
 * @param {number} [props.data.bookingTotal] - The booking total amount.
 * @param {number} [props.data.amountReceived] - The amount received.
 * @param {number} [props.data.totalDue] - The total due amount.
 * @param {string} [props.data.bookingDate] - The booking date.
 * @param {string} [props.data.departureDate] - The departure date.
 * @param {...any} props.rest - Additional props to be spread on the parent element.
 *
 * @returns {JSX.Element} React element representing the booking totals header.
 */
const BookingTotalsHeader = ({ id, data = {}, ...rest }) => {
  const { t } = useTranslation(['bookings']);

  //TODO: Remove the placeholder data when the actual API call is added
  return (
    <Box className='booking-totals-header' id={id} {...rest}>
      <BookingTotalsHeaderItem
        id={'booking-totals-header-item-booking-total'}
        title={t('bookings:bookingTotal')}
        value={data?.bookingTotal || '$AMOUNT USD'}
      />
      <BookingTotalsHeaderItem
        id={'booking-totals-header-item-amount-received'}
        title={t('bookings:amountReceived')}
        value={data?.amountReceived || '$AMOUNT USD'}
      />
      <BookingTotalsHeaderItem
        id={'booking-totals-header-item-total-due'}
        title={t('bookings:totalDue')}
        value={data?.totalDue || '$AMOUNT USD'}
      />

      <BookingTotalsHeaderItem
        id={'booking-totals-header-item-booking-date'}
        title={t('bookings:bookingDate')}
        value={data?.bookingDate || 'January 22, 2025'}
      />

      <BookingTotalsHeaderItem
        id={'booking-totals-header-item-departure-date'}
        title={t('bookings:departureDate')}
        value={data?.departureDate || 'June 30, 2025'}
      />
    </Box>
  );
};

BookingTotalsHeader.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  data: PropTypes.object
};

export default BookingTotalsHeader;
